export default "__VITE_ASSET__43575f21__"